import { tdwReport as iTdwReport } from '@tencent/imutils/dist/esm/util_26_tdw_report';

export function tdwReportUtil(...params) {
  if (window.VISION && window.VISION.meta.isEditor) {
    return console.log('Skip tdw report at editor: ', ...params);
  }
  return iTdwReport.report(...params);
}
